/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaStudenteAnagraficaDTO { 
    id?: string;
    nome?: string;
    cognome?: string;
    codice_fiscale?: string;
    data_nascita?: string;
    cittadinanza?: string;
    cellulare?: string;
    comune_residenza?: string;
    provincia_residenza?: string;
    indirizzo_residenza?: string;
    codice_pratica?: string;
    possesso_isee?: boolean;
    isee?: number;
    isee_anno?: number;
}

